import "./footer.css"

function Footer() {
  return (
    <div className="footer">
        <div className="flex flex-row items-center gap-2">
            {/* <img src="/qrcodeMD.png" alt="MolthanaBakery" className="w-8 rounded-md" /> */}
            <img src="/qrnoodles.png" alt="Noodles3N" className="w-8 rounded-md" />
            {/* <img src="/qrline.png" alt="MolthanaBakery" className="w-8 rounded-lg" /> */}
            <span>Noodles 3N</span>
        </div>
        <span>© freelance Dev</span>
    </div>
    )
}

export default Footer